import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ServicesHero from "./sections/ServicesHero";
import ServiceListings from "./sections/ServiceListings";
import RequestAConsultationCta from "./sections/RequestAConsultationCta";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ServicesHero />
      <ServiceListings />
      <RequestAConsultationCta />
      <Footer />
    </div>;
}